'use client';

import { useState } from 'react';
import clsx from 'clsx';
import styles from './image-with-fallback.module.scss';

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpva249InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4=';

export type ImageWithFallbackProps = React.ImgHTMLAttributes<HTMLImageElement>;

export default function ImageWithFallback({
  src,
  alt,
  className,
  style,
  ...rest
}: ImageWithFallbackProps) {
  const [didError, setDidError] = useState(false);

  if (didError) {
    return (
      <div className={clsx(styles.fallback, className)} style={style}>
        {/* Native img for error placeholder; next/image not used for data URI fallback */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={ERROR_IMG_SRC} alt="Error loading image" data-original-url={src} {...rest} />
      </div>
    );
  }

  return (
    /* eslint-disable-next-line @next/next/no-img-element -- Fallback component using native img for onError and flexible props */
    <img
      src={src}
      alt={alt ?? ''}
      className={className}
      style={style}
      onError={() => setDidError(true)}
      {...rest}
    />
  );
}
